module.exports = __webpack_public_path__ + "img/rewarded-coins.8fca0a1a.svg";